<template>
  <li :class="dropdownClasses">
    <a @click="handleClick">
      <i v-if="icon" v-bind="computedIcon"/>
      <span class="menu-title">{{name}}</span>
    </a>
    <ul class="menu-content" @click="itemClicked">
      <slot>
        <template v-for="(item, key) in items">
          <CSidebarNavItem v-bind="item" :key="key"/>
        </template>
      </slot>
    </ul>
  </li>
</template>

<script>
import CSidebarNavItem from './CSidebarNavItem'

export default {
  name:'CSidebarNavDropdown',
  components: {
    CSidebarNavItem
  },
  props: {
    name: String,
    route: {
      type: String,
      validator: val => val.length > 0
    },
    icon: [String, Object],
    fontIcon: String,
    show: Boolean,
    items: Array
  },
  data () {
    return {
      open: this.show
    }
  },
  inject: {
    dropdownMode: {
      default: 'openActive'
    }
  },
  watch: {
    show (val) {
      this.open = val
    },
    $route: {
      immediate: true,
      handler (route) {
        const mode = this.dropdownMode
        if (mode === 'close') {
          this.open = false
        } else if (mode === 'closeInactive' && this.route) {
          this.open = route.fullPath.includes(this.route)
        }  else if (mode === 'openActive' && !this.open && this.route) {
          this.open = route.fullPath.includes(this.route)
        }
        // else if (mode === 'noAction') {
        //   return
        // }
      }
    }
  },
  computed: {
    dropdownClasses () {
      return [
        'nav-item has-sub menu-collapsed-open',
        { 'open': this.open }
      ]
    },
    computedIcon () {
      if (typeof this.icon === 'object') {
        const key = this.icon.size ? 'class' : 'customClasses'
        return Object.assign(
          { [`${key}`]: 'c-sidebar-nav-icon' },
          this.icon
        )
      } else {
        return { class: this.icon }
      }
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      this.open = !this.open
      this.$emit('update:show', this.open)
    },
    itemClicked (e) {
      this.$emit('item-clicked', e)
    }
  }
}
</script>

<style scoped>
.menu-title {
    font-size: 16px;
    font-family: 'Avenir Next W1G Medium';
    vertical-align: middle;
}
</style>
